"use strict";

angular.module("customer")
.controller("SectionOrderDetails", function(
    $scope, $rootScope, $state, $stateParams, gettextCatalog, CustomerOrderService, OrderTemplateService,
    CartItemService, ModalService, FlashBag
) {
    $scope.order = null;
    $scope.orderId = $stateParams.id;
    $scope.service = CustomerOrderService;

    this.createTemplate = function() {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Create template"),
                    message: gettextCatalog.getString("Do you really want to create a template from this order?"),
                    confirmTextButton: gettextCatalog.getString("Create template")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    return;
                }
                OrderTemplateService.generateCartWithOrderTemplateFromOrder($scope.orderId).then(
                    function onSuccess(response) {
                        FlashBag.info(gettextCatalog.getString("You can now choose a name for your template and click 'Create template'."), true);
                        $rootScope.UpdateCurrentNumbers();
                        $state.go('shoppingCart');
                    }, function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            });
        });
    };

    this.reorder = function() {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Reorder"),
                    message: gettextCatalog.getString("Do you really want to reorder?"),
                    confirmTextButton: gettextCatalog.getString("Reorder")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (confirm) {
                    CartItemService.usePreviousOrder({order_id: $scope.orderId}).then(
                        function onSuccess() {
                            FlashBag.success(gettextCatalog.getString("The cart was generated successfully."), true);
                            $rootScope.UpdateCurrentNumbers();
                            $state.go('shoppingCart');
                        },
                        function onError(response) {
                            FlashBag.apiError(response);
                        }
                    );
                }
            });
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order/order-detail.controller.js
// module id = 899
// module chunks = 0